import type { AccessType } from '@bb/domain/dist/types';
import type {
  AccessKey,
  ConfirmationInstructions,
} from '@bb/domain/dist/types/AppointmentConfig';
import { pick } from 'lodash';

const parseInstructions = (
  access: AccessType,
  instructions: ConfirmationInstructions,
  options: {
    includeCommonFields?: boolean;
  } = {
    includeCommonFields: true,
  },
) => {
  const { includeCommonFields } = options;

  const commonKeys: Record<
    Exclude<keyof ConfirmationInstructions, AccessKey>,
    true
  > = {
    lights: true,
    card: true,
    shoes: true,
    lock_doors: true,
    callIfLate: true,
    knockFirst: true,
    alarm: true,
    confirmation: true,
    reco: true,
    none: true,
    showing_instructions: true,
  };

  const commonFields = includeCommonFields ? Object.keys(commonKeys) : [];

  switch (access) {
    case 'Direct':
      return pick(instructions, [...commonFields, 'direct']);
    case 'Door Code':
      return pick(instructions, [...commonFields, 'doorcode']);
    case 'Key':
      return pick(instructions, [...commonFields, 'key']);
    case 'Lock Box':
      return pick(instructions, [...commonFields, 'lockbox']);
    case 'MasterLock':
      return pick(instructions, [...commonFields, 'masterlock']);
    case 'SentriLock':
      return pick(instructions, [...commonFields, 'sentrilock']);
    case 'SentriLock App':
      return pick(instructions, [...commonFields, 'sentrilockapp']);
    case 'SentriLockV2':
      return pick(instructions, [...commonFields, 'sentrilockv2']);
    case 'Supra eKEY':
      return pick(instructions, [...commonFields, 'supraekey']);
    case 'Supra Lockbox':
      return pick(instructions, [...commonFields, 'supralockbox']);
    default:
      return instructions;
  }
};

export default parseInstructions;
